import React, { useState } from 'react';
import { Share2, Check, Copy } from 'lucide-react';
import { toast } from 'sonner';

/** WhatsApp + copy-link share controls for public profile pages. */
export const ShareButtons = ({ title, testidPrefix = 'share' }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const text = `${title} — check out this profile on ZenStudios: ${url}`;

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Profile link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Could not copy link.');
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid={`${testidPrefix}-buttons`}>
      <button
        onClick={shareWhatsApp}
        className="inline-flex items-center gap-1.5 text-sm font-medium bg-white/10 hover:bg-white/20 border border-white/20 text-white px-3.5 py-2 rounded-xl transition-colors"
        data-testid={`${testidPrefix}-whatsapp`}
      >
        <Share2 className="w-4 h-4" /> Share
      </button>
      <button
        onClick={copyLink}
        className="inline-flex items-center gap-1.5 text-sm font-medium bg-white/10 hover:bg-white/20 border border-white/20 text-white px-3.5 py-2 rounded-xl transition-colors"
        data-testid={`${testidPrefix}-copy`}
      >
        {copied ? <Check className="w-4 h-4 text-emerald-300" /> : <Copy className="w-4 h-4" />}
        {copied ? 'Copied' : 'Copy link'}
      </button>
    </div>
  );
};

export default ShareButtons;
